export const useToEmbed = () => {

    const toEmbed = (url) => {
        if (!url) return '';

        // www.youtube.com/watch?v=ABC
        if (url.includes('watch?v=')) {
            const id = url.split('watch?v=')[1]?.split('&')[0];
            return id ? `https://www.youtube.com/embed/${id}` : url;
        }

        // youtu.be/ABC
        if (url.includes('youtu.be/')) {
            const id = url.split('youtu.be/')[1]?.split('?')[0];
            return id ? `https://www.youtube.com/embed/${id}` : url;
        }

        return url;
    };
    return toEmbed;
};